import { apiRequest } from '@/lib/apiClient';
import type { Obra } from '@/types';

export function fetchObras(mes?: string, includeArquivadas = false): Promise<Obra[]> {
  const search = new URLSearchParams();
  if (mes) search.set('mes', mes);
  if (includeArquivadas) search.set('includeArquivadas', 'true');
  const q = search.toString();
  return apiRequest<Obra[]>(`/api/obras${q ? `?${q}` : ''}`);
}

export function createObra(nome: string, centroCusto?: string | null): Promise<Obra> {
  return apiRequest<Obra>('/api/obras', { method: 'POST', body: { nome, centroCusto } });
}

export function updateObra(
  id: string,
  input: { nome: string; centroCusto?: string | null; arquivada?: boolean },
): Promise<Obra> {
  return apiRequest<Obra>(`/api/obras/${id}`, { method: 'PUT', body: input });
}

export function deleteObra(id: string): Promise<void> {
  return apiRequest<void>(`/api/obras/${id}`, { method: 'DELETE' });
}
